;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { QuickbooksProviderForm } from "@/components/settings/data-providers/provider-forms/quickbooks-provider-form";
import { ZoomProviderForm } from "@/components/settings/data-providers/provider-forms/zoom-provider-form";
import { ProviderType } from "@/types/dataProvider";
import {
	AppFolioDatabaseApiProviderForm,
	AppFolioReportingApiProviderForm,
} from "./app-folio-provider-form";
import { AsanaProviderForm } from "./asana-provider-form";
import { CallLinksProviderForm } from "./call-links-provider-form";
import { GAdminProviderForm } from "./g-admin-provider-form";
import { GmeliusProviderForm } from "./gmelius-provider-form";
import { GoToConnectProviderForm } from "./goto-connect-provider-form";
import { OpiniionProviderForm } from "./opiniion-provider-form";
import { PodiumProviderForm } from "./podium-provider-form";
import { RentEngineProviderForm } from "./rentengine-provider-form";
import { RentvineProviderForm } from "./rentvine-provider-form";
import { ShowMojoProviderForm } from "./showmojo-provider-form";
import { YardiProviderForm } from "./yardi-provider-form";

export const PROVIDER_FORM_REGISTRY = {
	[ProviderType.YARDI]: YardiProviderForm,
	[ProviderType.APP_FOOLIO]: AppFolioReportingApiProviderForm,
	[ProviderType.APPFOLIO_DATABASE]: AppFolioDatabaseApiProviderForm,
	[ProviderType.QUICKBOOKS]: QuickbooksProviderForm,
	[ProviderType.ZOOM]: ZoomProviderForm,
	[ProviderType.OPINIION]: OpiniionProviderForm,
	[ProviderType.GADMIN]: GAdminProviderForm,
	[ProviderType.GMELIUS]: GmeliusProviderForm,
	[ProviderType.GOTO_CONNECT]: GoToConnectProviderForm,
	[ProviderType.CALL_LINKS]: CallLinksProviderForm,
	[ProviderType.PODIUM]: PodiumProviderForm,
	[ProviderType.RENTENGINE]: RentEngineProviderForm,
	[ProviderType.SHOWMOJO]: ShowMojoProviderForm,
	[ProviderType.ASANA]: AsanaProviderForm,
	[ProviderType.RENTVINE]: RentvineProviderForm,
} as const;

export type {
	BaseProviderFormProps,
	ProviderFormComponent,
} from "./base-provider-form";
export type { ProviderConfig, StepDefinition } from "./provider-config";
export { PROVIDER_CONFIGS } from "./provider-configs";
export { useProviderFlow } from "./use-provider-flow";
export {
	AppFolioDatabaseApiProviderForm,
	AppFolioReportingApiProviderForm,
	AsanaProviderForm,
	CallLinksProviderForm,
	GAdminProviderForm,
	GmeliusProviderForm,
	GoToConnectProviderForm,
	OpiniionProviderForm,
	PodiumProviderForm,
	RentEngineProviderForm,
	RentvineProviderForm,
	ShowMojoProviderForm,
	YardiProviderForm,
};
